import { render } from "./SectionEvent.vue?vue&type=template&id=310ca958"
import script from "./SectionEvent.vue?vue&type=script&lang=js"
export * from "./SectionEvent.vue?vue&type=script&lang=js"

import "./SectionEvent.vue?vue&type=style&index=0&id=310ca958&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__